import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DataPage.css';

import { API_URL } from '../config';
import { formatDate } from '../utils/formatDate';

function Locais() {
  const [locais, setLocais] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLocais();
  }, []);

  const fetchLocais = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/locais`);
      setLocais(response.data || []);
    } catch (err) {
      console.error('Erro ao buscar locais:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatarValor = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (value === 'T' || value === 't') return 'Sim';
    if (value === 'F' || value === 'f') return 'Não';
    return String(value);
  };

  // formatDate importado de ../utils/formatDate

  if (loading) {
    return <div className="loading">Carregando locais...</div>;
  }

  const styles = {
    pageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '12px',
    },
    pageIcon: {
      fontSize: '1.5rem',
      lineHeight: 1,
    },
    pageTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1a1a2e',
      margin: '0 0 2px 0',
    },
    pageSubtitle: {
      fontSize: '0.85rem',
      color: '#666',
      margin: 0,
    },
  };

  return (
    <div className="data-page">
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>📍</span>
          <div>
            <h1 style={styles.pageTitle}>Locais</h1>
            <p style={styles.pageSubtitle}>Total: {locais.length} locais cadastrados</p>
          </div>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descrição</th>
              <th>Cidade</th>
              <th>UF</th>
              <th>CEP</th>
              <th>Telefone</th>
              <th>Email</th>
              <th>Inativo</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            {locais.map((local) => (
              <tr key={local.ID}>
                <td><strong>{local.ID}</strong></td>
                <td><strong>{local.DESCRICAO}</strong></td>
                <td>{formatarValor(local.CIDADE)}</td>
                <td>{formatarValor(local.UF)}</td>
                <td>{formatarValor(local.CEP)}</td>
                <td>{formatarValor(local.TELEFONE)}</td>
                <td>{formatarValor(local.EMAIL)}</td>
                <td>
                  <span style={{
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    background: local.INATIVO === 'T' ? '#fee2e2' : '#d1fae5',
                    color: local.INATIVO === 'T' ? '#dc2626' : '#059669'
                  }}>
                    {local.INATIVO === 'T' ? 'Inativo' : 'Ativo'}
                  </span>
                </td>
                <td>{formatDate(local.DATA)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {locais.length === 0 && !loading && (
        <div className="no-data">
          <p>Nenhum local encontrado.</p>
        </div>
      )}
    </div>
  );
}

export default Locais;
